import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const SUGMDT2 = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'><ol><li><b>Open</b> the downloaded <b>PDB file</b> and you will be shown a window asking you for the elements to be included.</li><li>Unmark everything except the chains you want to study and accept your selection.</li><li>Export the file.</li></ol></Text>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SUGMDT2;
